<template>
  <div class="resources-list">
    <div class="resources-list__section" v-if="scannedResources.length">
      <div class="resources-list__section-title ms-help">Сканы</div>
      <div class="resources-list__section-items">
        <resources-item
          v-for="resource in scannedResources"
          :key="resource.id"
          :resource="resource"
        />
      </div>
    </div>
    <div class="resources-list__section" v-if="workingResources.length">
      <div class="resources-list__section-title ms-help">Рабочий формат</div>
      <div class="resources-list__section-items">
        <resources-item
          v-for="resource in workingResources"
          :key="resource.id"
          :resource="resource"
        />
      </div>
    </div>
    <div class="resources-list__section" v-if="otherResources.length">
      <div
        v-for="group in bgsDocuments"
        :key="group.id"
        class="resources-list__bgs-container"
      >
        <div
          class="resources-list__bgs-category"
          v-for="category in group.categories"
          :key="category.id"
        >
          <div class="resources-list__section-title ms-help">
            {{ category.name }}
          </div>
          <div class="resources-list__section-items">
            <resources-item
              v-for="resource in category.resources"
              :key="resource.id"
              :resource="resource"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResourcesItem from './resources-item'
import { bgsFileTypes } from '@/config/bgs'

export default {
  components: {
    ResourcesItem
  },
  props: ['resources'],
  computed: {
    sortedResources () {
      if (!this.resources.length) return []

      if (this.resources[0].file_type_index) {
        return [...this.resources].sort(
          (a, b) => a.file_type_index - b.file_type_index
        )
      }

      return this.resources
    },
    scannedResources () {
      return this.sortedResources.filter(r => r.format_type_id === 1)
    },
    workingResources () {
      return this.sortedResources.filter(r => r.format_type_id === 2)
    },
    otherResources () {
      return this.sortedResources.filter(r => r.format_type_id === null)
    },
    bgsDocuments () {
      return bgsFileTypes.map(g => ({
        ...g,
        categories: g.categories
          .map(t => ({
            ...t,
            resources: this.getBgsGroupResources(t.id)
          }))
          .filter(t => !!t.resources.length)
      }))
    }
  },
  methods: {
    getBgsGroupResources (id) {
      return this.otherResources.filter(r => r.file_type_id === id)
    }
  }
}
</script>

<style lang="less">
.resources-list {
  display: flex;

  &__section {
    flex: 1;

    &:not(:first-child) {
      margin-left: 32px;
    }

    &-title {
      margin-bottom: 4px;
    }
  }

  &__bgs-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 32px;
    row-gap: 4px;

    &:not(:first-child) {
      margin-top: 16px;
    }
  }
}
</style>
